<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import RadioButtons from '~/components/form-elements/RadioButtons.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import PickUpPoint from '~/enums/pick-up-point'
import { useCartStore } from '~/store/cart'
import type { RadioButtonChoice } from '~/types/form-elements'

const model = defineModel<boolean>()

const pickUpPointChoices = PickUpPoint
  .sortedMembers
  .filter((x: PickUpPoint): boolean => PickUpPoint.isActive(x))
  .map(
    (x: PickUpPoint): RadioButtonChoice => ({
      description: PickUpPoint.getDescription(x),
      labelText: PickUpPoint.getName(x),
      value: x
    })
  )

const cartStore = useCartStore()

const pickUpPoint = ref<PickUpPoint | null>(null)

function close (): void {
  model.value = false
}

function confirmSelection (): void {
  if (pickUpPoint.value) {
    cartStore.shippingCostInKopecks = 0
    cartStore.shippingData = { pickUpPointId: pickUpPoint.value as PickUpPoint }
  }

  close()
}
</script>

<template>
  <CustomModalWindow v-model="model" size="large">
    <template #title>
      Выбор пункта самовывоза в&nbsp;Москве
    </template>

    <RadioButtons
      v-model="pickUpPoint"
      :choices="pickUpPointChoices"
      class="mb-6"
      is-vertical
      label-text="Пункт самовывоза"
      name="pickUpPointId"
      with-blocks
    />

    <BasicButton v-if="pickUpPoint" color="green" title="Подтвердить выбор" @click="confirmSelection" />

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
